<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listContributionRange"
        title-table="Faixa de Contribuição"
        module="contributionRangeSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_FAIXA_CONTRIBUICAO_INSERIR"
        view-permission="ROLE_FAIXA_CONTRIBUICAO_CONSULTAR"
        edit-permission="ROLE_FAIXA_CONTRIBUICAO_ATUALIZAR"
        delete-permission="ROLE_FAIXA_CONTRIBUICAO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormContributionRange
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormContributionRange from './forms/FormContributionRange.vue'

export default {
  name: 'ContributionRange',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormContributionRange,
  },
  computed: {
    ...mapState('contributionRangeSettingsModule', {
      listContributionRange: state => state.listContributionRange,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'descricao',
        },
        {
          label: 'Ano',
          field: 'ano',
        },
        {
          label: 'Valor',
          field: 'valor',
          formatFn: this.formatCurrencyBrazil,
        },
        {
          label: 'Vencimento',
          field: 'vencimento',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'contributionRangeSettingsModule/prepareToEditContributionRange',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
